import axios from "axios";
import { FETCH_ALL_DIVISION_API } from "../Constants/Apis";

export const getDivisions = async () => {
  try {
    return axios.get(FETCH_ALL_DIVISION_API);
  } catch (e) {
    return console.log(e);
  }
};

export const createDivision = async (payload) => {
  try {
    return axios.post(FETCH_ALL_DIVISION_API, payload);
  } catch (e) {
    return console.log(e);
  }
};

export const updateDivision = async (id, payload) => {
  try {
    return axios.put(`${FETCH_ALL_DIVISION_API}/${id}`, payload);
  } catch (e) {
    return console.log(e);
  }
};

export const deleteDivision = async (id) => {
  try {
    return axios.delete(`${FETCH_ALL_DIVISION_API}/${id}`);
  } catch (e) {
    return console.log(e);
  }
};

